/**
 * Dialog Component Tokens
 *
 * Defines the visual styling for PrimeNG Dialog/Modal component.
 * These tokens map to semantic tokens for consistent theming.
 *
 * Token structure follows PrimeNG's dialog design token specification:
 * - background, borderColor, color, borderRadius, shadow for root
 * - header, title, content, footer for sections
 *
 * Note: Color scheme (light/dark) is handled automatically by semantic token
 * references like {overlay.modal.background} which resolve based on the
 * active color scheme defined in semantic.tokens.ts
 */
export const dialogTokens = {
  dialog: {
    // Root dialog styling - uses semantic tokens that auto-switch for light/dark
    background: '{overlay.modal.background}',
    borderColor: '{overlay.modal.borderColor}',
    color: '{overlay.modal.color}',
    borderRadius: '{borderRadius.lg}',
    shadow: '0px 20px 34px 0px rgba(53, 67, 88, 0.08)',

    // Header section
    header: {
      padding: '2rem 2rem 0',
      gap: '1rem'
    },

    // Title styling
    title: {
      fontSize: '1.125rem',
      fontWeight: '600'
    },

    // Content section
    content: {
      padding: '0'
    },

    // Footer section
    footer: {
      padding: '0 2rem 2rem',
      gap: '0.5rem'
    }
  }
};

export type DialogTokens = typeof dialogTokens;
